<template>
<div 
    class="h-100"
    :class="[loading ? 'loading' : '']">

    <h2 class="step-title" v-text="__('trads.Set-your-payment-method')"></h2>

    <div class="d-flex justify-content-center align-items-center mb-4 mt-1">
        <img src="/img/enveloppe.svg" alt="">
        <h3 class="subscription-start text-center m-0 ml-2" v-text="__('giftcard.starts-immediately')"></h3>
    </div>

    <div class="payment-recap">
        <div class="plan-sub text-left">
            <div class="period" v-text="__('giftcard.duration')"></div>
            <div class="billing-time" v-text="plan.price.formatted"></div>

            <span
                class="money-saved"
                v-text="__('trads.percent-saved', {percent: 30})"
                v-if="plan.highlighted"
                >
            </span>

            <div class="gift-recap mt-2">
                {{ __('giftcard.recap.sender') }}
                <span class="name mx-1" v-text="sender_name"></span>
                <span class="email">({{ sender_email }})</span>
            </div>
            <div class="gift-recap">
                {{ __('giftcard.recap.recipient') }}
                <span class="name mx-1" v-text="recipient_name"></span>
                <span class="email">({{ recipient_email }})</span>
            </div>
            <div class="gift-recap my-2" v-if="message">
                {{ __('giftcard.recap.message') }}
                <span class="email ml-1" v-text="message"></span>
            </div>

        </div>
        <a class="change-plan" @click.prevent="previous" href="">{{ __('trads.Change') }}</a>
    </div>

    <hr class="my-3">

    <div class="loader">
        <div class="secured-payment d-flex">
            {{ __('trads.Secured-payment') }}
            <img src="/img/style/secured-payment.svg">
        </div>
    
        <div id="payment-element" class="mt-4">
        </div>
    
        <button 
            @click="pay"
            type="button" 
            class="d-flex justify-content-center align-items-center mt-4 btn btn-authent btn-lg btn-block cg-submit">
            {{ this.__('trads.Purchase') }}
            <img class="next-arrow" src="/img/style/next-arrow.svg">
        </button>
    </div>

</div>

</template>

<script>
import Vue from 'vue';
import store from './store.js';

export default {
    store,
    props: ['selected', 'email', 'coupon'],
    data () {
        return {
            period: '',
            loading: null,
            plan: store.state.plan,
            recipient_name: store.state.recipient_name,
            recipient_email: store.state.recipient_email,
            sender_name: store.state.sender_name,
            sender_email: store.state.sender_email,
            message: store.state.message,
            success_url: store.state.success_url,
            stripe: {},
            elements: {},
        }
    },

    beforeMount () {
        // for (var n in this.$parent.plans) {
        //     var plan = this.$parent.plans[n];
        //     if (this.selected == plan.id) {
        //         this.currentPlan = plan;
        //         break;
        //     }
        // }
    },
    mounted () {
        this.open();
    },
    methods: {
        previous () {
            this.$parent.previousStep();
        },
        async pay () {
            this.loading = true;
            var elements = this.elements;

            // Trigger form validation and wallet collection
            const {error: submitError} = await elements.submit();
            if (submitError) {
                handleError(submitError);
                return;
            }
            
            // Create the PaymentIntent and obtain clientSecret
            let prepareUrl = "/api/gift/prepare";
            const res = await fetch(prepareUrl, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    lang: this.$lang().getLocale(),
                    sender_email: this.sender_email,
                    sender_name: this.sender_name,
                    recipient_email: this.recipient_email,
                    recipient_name: this.recipient_name,
                    message: this.message,
                })
            });

            const {client_secret: clientSecret} = await res.json();


            this.stripe
                .confirmPayment({
                    elements,
                    clientSecret,
                    confirmParams: {
                        return_url: this.success_url,
                    },
                })
                .then(function(result) {
                    console.log(result);
                    this.loading = false;
                    // Handle result.error or result.paymentMethod
                });
            /*
            // ref in template
            const groupComponent = this.$refs.elms
            const cardComponent = this.$refs.card
            // Get stripe element
            const cardElement = cardComponent.stripeElement

            // Access instance methods, e.g. createToken()
            groupComponent.instance.createToken(cardElement).then(result => {
                // Handle result.error or result.token
            })
            */
        },
        open () {
            this.stripe = Stripe(store.state.stripe_key, {
                locale: this.$lang().getLocale()
            });

            // https://stripe.com/docs/elements/appearance-api?platform=web#theme
            const appearance = {
              theme: 'stripe'
            };

            const options = {
                mode: 'payment',
                currency: this.plan.price.currency,
                amount: this.plan.price.unit_amount,
                appearance,
            };

            // Set up Stripe.js and Elements to use in checkout form, passing the client secret obtained in step 2
            this.elements = this.stripe.elements(options);

            // Create and mount the Payment Element
            const paymentElement = this.elements.create('payment', {
                layout: {
                    type: 'tabs',
                    defaultCollapsed: false
                }
            });
            paymentElement.mount('#payment-element');
            paymentElement.on('ready', function(event) {
                paymentElement._parent.parentElement.classList.remove('loading');
            });
        }
    },
}
</script>

<style>
</style>
